import React from "react";
import ReactDOM from "react-dom";
import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/storage";
import "firebase/firestore";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { RecoilRoot } from "recoil";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
  apiKey: "AIzaSyCAbmhpmbcvPg3V1L-29oS-4ilpDpQfZiI",
  authDomain: "trail-app-ffb9b.firebaseapp.com",
  projectId: "trail-app-ffb9b",
  storageBucket: "trail-app-ffb9b.appspot.com",
  messagingSenderId: "82260097547",
  appId: "1:82260097547:web:3a7e604dbc36b08178650e",
  measurementId: "G-QTKXD900ET",
};
// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
firebase.analytics();

firebase
  .firestore()
  .enablePersistence()
  .catch((e) => console.error(e));

export const storage = firebase.storage();
export const db = app.firestore();

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
